
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerJungleLogMid from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogMid";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import CheckpointMarker from "../../editor/CheckpointMarker";
import PlatformMarkerBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerBarrel";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import PlatformMarkerLog from "../../editor/platform-markers/shipwreck/PlatformMarkerLog";
import MoverData from "../../../components/platformer/MoverData";
import PositionMarker from "../../editor/PositionMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkHard1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 221, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6380, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 541, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 230, 139);
    this.add(pole_long_float_png);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1441, 207);
    this.add(platformCabin);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1203, -348);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 4504, 143);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 4318, -356);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 4094, -358);
    this.add(gemMarker_3);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 3752, -123);
    this.add(crateMarker);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1396, 103);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1513, 99);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3569, -66);
    this.add(gemMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 3846, -358);
    this.add(gemMarker_10);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 2933, -705);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 825, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4003, -56);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 1981, 139);
    this.add(megaGemMarker_1);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 682, -2);
    this.add(platformMarkerLogLong);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerJungleLogMid(scene, 5850, 32);
    this.add(platformMarkerLogMid);

    // platformMarkerLogLong_2
    const platformMarkerLogLong_2 = new PlatformMarkerJungleLogLong(scene, 4114, -270);
    this.add(platformMarkerLogLong_2);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, 832, 139);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 1118, 139);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 4206, 139);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 3920, 139);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 3629, 139);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 3318, 139);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 3770, 9);
    this.add(platformMarkerLogLong_3);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 4495, 240);
    this.add(platformMarkerSubmergedBarrel);

    // platformMarkerSubmergedBarrel_1
    const platformMarkerSubmergedBarrel_1 = new PlatformMarkerSubmergedBarrel(scene, 4842, 240);
    this.add(platformMarkerSubmergedBarrel_1);

    // platformCabin_1
    const platformCabin_1 = new PlatformMarkerCabin(scene, 5263, 211);
    this.add(platformCabin_1);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 5274, 98);
    this.add(megaGemMarker_3);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 419, -29);
    this.add(checkpointMarker);

    // checkpointMarker_3
    const checkpointMarker_3 = new CheckpointMarker(scene, 3895, -316);
    this.add(checkpointMarker_3);

    // platformBarrel_1
    const platformBarrel_1 = new PlatformMarkerBarrel(scene, 1202, -236);
    this.add(platformBarrel_1);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 1552, -471);
    this.add(gemMarker_4);

    // platformBarrel
    const platformBarrel = new PlatformMarkerBarrel(scene, 1551, -359);
    this.add(platformBarrel);

    // platformBarrel_2
    const platformBarrel_2 = new PlatformMarkerBarrel(scene, 1890, -471);
    this.add(platformBarrel_2);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2480, -625);
    this.add(megaGemMarker_2);

    // platformLog
    const platformLog = new PlatformMarkerJungleLog(scene, 2374, -559);
    this.add(platformLog);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 2328, -696);
    this.add(crateMarker_1);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 1892, -593);
    this.add(gemMarker_5);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerLog(scene, 2992, -602);
    this.add(platformLog_1);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2992, -596);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 3262, -596);
    this.add(positionMarker_1);

    // megaGemMarker_4
    const megaGemMarker_4 = new MegaGemMarker(scene, 3811, -746);
    this.add(megaGemMarker_4);

    // platformLog_2
    const platformLog_2 = new PlatformMarkerJungleLog(scene, 3705, -680);
    this.add(platformLog_2);

    // crateMarker_2
    const crateMarker_2 = new SmashableMarkerCrate(scene, 3659, -817);
    this.add(crateMarker_2);

    // platformMarkerSubmergedBarrel_2
    const platformMarkerSubmergedBarrel_2 = new PlatformMarkerSubmergedBarrel(scene, 1969, 236);
    this.add(platformMarkerSubmergedBarrel_2);

    // pole_long_float_png_2
    const pole_long_float_png_2 = new DecorationFloatingPoleLong(scene, 5615, 167);
    this.add(pole_long_float_png_2);

    // pole_long_float_png_3
    const pole_long_float_png_3 = new DecorationFloatingPoleLong(scene, 6072, 167);
    this.add(pole_long_float_png_3);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 5739, -77);
    this.add(gemMarker_9);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 5980, -79);
    this.add(gemMarker_15);

    // platformMarkerSubmergedBarrel_3
    const platformMarkerSubmergedBarrel_3 = new PlatformMarkerSubmergedBarrel(scene, 2393, 225);
    this.add(platformMarkerSubmergedBarrel_3);

    // platformMarkerSubmergedBarrel_4
    const platformMarkerSubmergedBarrel_4 = new PlatformMarkerSubmergedBarrel(scene, 2882, 237);
    this.add(platformMarkerSubmergedBarrel_4);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 2390, -841);
    this.add(platformLog_3);

    // platformLog_4
    const platformLog_4 = new PlatformMarkerJungleLog(scene, 3739, -962);
    this.add(platformLog_4);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // crateMarker (components)
    const crateMarkerSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker);
    crateMarkerSimpleBreakableBlocker.allowedCharacter = "grizz";

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "grizz";

    // platformLog_1 (components)
    const platformLog_1MoverData = new MoverData(platformLog_1);
    platformLog_1MoverData.startMarker = positionMarker;
    platformLog_1MoverData.endMarker = positionMarker_1;
    platformLog_1MoverData.startWait = 800;

    // crateMarker_2 (components)
    const crateMarker_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_2);
    crateMarker_2SimpleBreakableBlocker.allowedCharacter = "panda";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
